import React, { useState } from "react";
import { RupeesIcon, ResetIcon } from "../../components/HeaderSidebarIcons";
import { Button } from "@heroui/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@heroui/react";

const stakeNum = [5, 10, 50, 100, 200, 500, 1000, 5000];

export default function Stake({
  selectedStake,
  setSelectedStake,
  stakeInput,
  setStakeInput,
  minMaxMap,
  selectedType,
  canOpenBet,
  canCloseBet,
  betTime,
  matchData,
}) {
   const entries = matchData?.data || [];
  const singlePatti = entries.find((item) => item?.type_id === 2);
  const jodi = entries.find((item) => item?.type_id === 5);
  const singlePattiOpenResult = singlePatti?.open_result;
  const jodiEntry = jodi?.close_result;
  const singlePattiCloseResult = singlePatti?.close_result;
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [modalMessage, setModalMessage] = useState("");
  const openModalWithMessage = (message) => {
    setModalMessage(message);
    onOpen();
  };
  return (
    <div className="border-t border-b border-gray-300 bg-white  p-1  w-full">
      <h1 className="text-center font-medium  text-m_red">Select Amounts</h1>
      {/* <span>Rate : 350</span> */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-1">
        <div className="grid grid-cols-4 sm:grid-cols-4 gap-4 w-full p-2">
          {stakeNum.map((number, index) => (
            <Button
              key={index}
              size="md"
              onClick={() => {
                if (betTime === "open" && singlePattiOpenResult) {
                  openModalWithMessage(
                    "Cannot place bet.Open Type Result already published"
                  );
                  return;
                }
                 if (betTime === "close" && singlePattiCloseResult) {
                  openModalWithMessage(
                    "Cannot place bet.Result already published"
                  );
                  return;
                }
                if (betTime === "open" && !canOpenBet) {
                  openModalWithMessage("Bet is closed for Open type");
                  return;
                } else if (betTime === "close" && !canCloseBet) {
                  openModalWithMessage("Bet is closed for Close type");
                  return;
                }
                setSelectedStake(number);
              }}
              className={`h-8 min-w-[60px] sm:min-w-[100px] w-full font-semibold border border-gray-300 
                ${
                  selectedStake === number
                    ? "bg-m_peach text-black"
                    : "bg-white"
                }
                hover:bg-m_peach hover:text-black transition-colors`}
              variant="flat"
              color="default"
              style={{
                borderRadius: "5px",
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div className="flex flex-col items-center">
                <div className="flex">
                  <span className="text-sm text-black-50">
                    <RupeesIcon />
                  </span>
                  <span>{number}</span>
                </div>
              </div>
            </Button>
          ))}
        </div>
      </div>
      {/* <div className="p-3 mt-1">
        <div className="flex justify-end mb-1">
          <div className="flex items-center text-xl font-medium text-right">
            Selected Stake:
            <span id="total-stake" className="ml-1">
              {selectedStake !== null ? selectedStake : "0"}
            </span>
            <span
              className="bg-white font-bold p-1 text-blue-800 cursor-pointer"
              onClick={() => setSelectedStake(0)}
            >
              <ResetIcon className="w-6 h-4 font-bold" />
            </span>
          </div>
        </div>
        <div className="flex justify-end mb-1">
          <div className="flex items-center text-md font-medium text-right mr-14">
            <span>
              ({minMaxMap[selectedType]?.min_stake} -{" "}
              {minMaxMap[selectedType]?.max_stake})
            </span>
          </div>
        </div>
      </div> */}
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        classNames={{
          backdrop: "bg-black/35",
          wrapper:
            "flex items-center justify-center min-h-screen sm:-mt-10 md:-mt-8",
        }}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalBody className="flex items-center justify-center min-h-[80px] p-0">
                <p className="text-center font-semibold">{modalMessage}</p>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </div>
  );
}
